/**
 * This container ID value is used as an ID on an element to allow the SlideInModalPortal to inject itself as a child of that element and render at that point in the DOM.
 *
 * This ID needs to be set on a component that launches a SlideInModalPortal, otherwise the modal will render outside the application's DOM and above other modals
 *
 * Read more about this component's behavior here: https://dev.synchronycredit.com/component-library/?path=/docs/patterns-modal-slide-in-portal--default
 */
var SLIDE_IN_MODAL_CONTAINER_ID = 'appWrapper';
export var MOCK_QUESTIONNAIRE_CONTAINER_ID = 'mock-questionnaire';
export var REPLACEMENT_CARD_PORTAL_ID = 'replacementCardWrapper';
export var ELIGIBILITY_PORTAL_ID = 'eligibilityStatus';
export default SLIDE_IN_MODAL_CONTAINER_ID;
//# sourceMappingURL=modalContainerIds.js.map